import {Tasks} from 'modules/Tasks';

export default Tasks;
